export default __webpack_public_path__ + "static/media/qr_chplay_okara_ht.e974ab22.svg";